import Schema from './schema'
import {SCH_GEN} from '../Data/typeDirs'
//dothiung
class GenericSchema extends Schema {

  constructor(p){
    super(p)
    this.typeDir = GenericSchema.getTypeDir()
  }

  static getTypeDir(){
    return SCH_GEN
  }

  static getExt(){
    return 'schema.json'
  }

  getSchema(dir = SCH_GEN){
    return Schema.tryGetAttr(dir, x=>this.content.content[0].schema)
  }

  setSource(schema){
    this.content = {
      0: {
        schema
      }
    }
  }

}

if( typeof window !== 'undefined') window._ms_GenericSchema = GenericSchema

export default GenericSchema
